module.exports = __webpack_public_path__ + "static/img/wordpress.5a8c835b.png";